"use client";

import type { Table } from "@tanstack/react-table";
import { createContext, use } from "react";

interface DataTableContextValue<TData = unknown> {
  searchValue: string;
  setSearchValue: (value: string) => void;
  table: Table<TData>;
}

// biome-ignore lint/suspicious/noExplicitAny: dynamic external type
const DataTableContext = createContext<DataTableContextValue<any> | null>(null);

function useDataTable<TData>(): Table<TData> {
  const context = use(DataTableContext);
  if (!context) {
    throw new Error(
      "DataTable compound components must be used within <DataTable>."
    );
  }
  return context.table as Table<TData>;
}

function useDataTableSearch(): {
  searchValue: string;
  setSearchValue: (value: string) => void;
} {
  const context = use(DataTableContext);
  if (!context) {
    throw new Error(
      "DataTable compound components must be used within <DataTable>."
    );
  }
  return {
    searchValue: context.searchValue,
    setSearchValue: context.setSearchValue,
  };
}

export type { DataTableContextValue };
export { DataTableContext, useDataTable, useDataTableSearch };
